var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemoveFromQueue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "remove_from_queue"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7 9.75H13V8.25H7V9.75ZM7 17V15H3.5C3.0875 15 2.73438 14.8531 2.44063 14.5592C2.14688 14.2653 2 13.9119 2 13.4992V4.49417C2 4.08139 2.14688 3.72917 2.44063 3.4375C2.73438 3.14583 3.0875 3 3.5 3H16.5C16.9125 3 17.2656 3.14694 17.5594 3.44083C17.8531 3.73472 18 4.08806 18 4.50083V13.5058C18 13.9186 17.8531 14.2708 17.5594 14.5625C17.2656 14.8542 16.9125 15 16.5 15H13V17H7ZM3.5 13.5H16.5V4.5H3.5V13.5Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveFromQueue);
export default __webpack_public_path__ + "static/media/remove_from_queue.7683298dcb25ed011d85b0651e151ff1.svg";
export { ForwardRef as ReactComponent };